import type { Jsonable } from "@/utils"
import { invariant } from "@/utils"

export const setStorageValue = (key: string, value: Jsonable) => {
  localStorage.setItem(key, JSON.stringify(value))
}

/**
 * Undefined when doesn't exist. null is actually a retrieved value
 */
export const getStorageValue = <TValue extends Jsonable>(
  key: string,
): TValue | undefined => {
  const jsonValue = localStorage.getItem(key)

  return jsonValue ? (JSON.parse(jsonValue) as TValue) : undefined
}

export const removeStorageValue = (key: string) => {
  localStorage.removeItem(key)
}

// returns function to remove listener
export const onStorageChange = <TValue extends Jsonable>(
  key: string,
  callback: (value: TValue) => void,
) => {
  const onValueChanged = (event: StorageEvent) => {
    if (event.key === key) {
      const value = getStorageValue<TValue>(key)
      invariant(value !== undefined)
      callback(value)
    }
  }

  window.addEventListener("storage", onValueChanged)

  return () => {
    window.removeEventListener("storage", onValueChanged)
  }
}
